import { render } from "./ContractIcon.vue?vue&type=template&id=61c110a0"
const script = {}
script.render = render

export default script